export const ZOOM_TYPES = {
  SOFT: {
    tooltip: 'my_video.tools.zoom.type.tooltip_soft',
    type: 'soft',
  },
  HARD: {
    tooltip: 'my_video.tools.zoom.type.tooltip_hard',
    type: 'hard',
  },
};
